import { Column, NumberInput, Text } from '@lightspeed/design-system-react'
import * as React from 'react'
import { useT } from '@transifex/react'
import { MAX_HOURS_AND_MINUTES, MIN_HOURS_AND_MINUTES } from '../../constants'
import { SCHEDULE_INPUT_BOX_TYPE } from '../types'

interface Props {
  label: SCHEDULE_INPUT_BOX_TYPE
  onError: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChange: (val: number) => void
  inputValue: number | null
}

export const ServiceSchedulingInput: React.FC<Props> = ({
  label,
  onError,
  onChange,
  inputValue,
}) => {
  const STEPPER_INCREMENT = 15
  const t = useT()
  const copy = {
    [SCHEDULE_INPUT_BOX_TYPE.HOURS]: t('Hours', {
      _context: 'Subtitle for scheduling step in service modal.',
    }),
    [SCHEDULE_INPUT_BOX_TYPE.MINUTES]: t('Minutes', {
      _context: 'Subtitle for scheduling step in service modal.',
    }),
  }

  const HOURS_AND_MINUTES_ERROR = {
    NON_CHARACTER_ERROR: `Enter numbers only`,
    INVALID_INPUT_ERROR: `Enter a valid input`,
    MAX_ERROR: `Enter a max of ${MAX_HOURS_AND_MINUTES.toLocaleString()}`,
  }

  return (
    <Column width="3/12">
      <div className="vd-pb1">
        <Text tag="span" type="label">
          {copy[label]}
        </Text>
        <NumberInput
          errorMessages={{
            max: HOURS_AND_MINUTES_ERROR.MAX_ERROR,
            nonDecimal: HOURS_AND_MINUTES_ERROR.INVALID_INPUT_ERROR,
            nonNegative: HOURS_AND_MINUTES_ERROR.INVALID_INPUT_ERROR,
            numbersOnly: HOURS_AND_MINUTES_ERROR.NON_CHARACTER_ERROR,
          }}
          validators={{
            max: true,
            nonDecimal: true,
            nonNegative: true,
          }}
          onError={onError}
          min={MIN_HOURS_AND_MINUTES}
          max={MAX_HOURS_AND_MINUTES}
          onChange={onChange}
          step={
            label === SCHEDULE_INPUT_BOX_TYPE.MINUTES
              ? STEPPER_INCREMENT
              : undefined
          }
          value={inputValue || undefined}
          data-testid={`service-scheduling-input-${label.toLowerCase()}`}
        />
      </div>
    </Column>
  )
}
